import React, { useContext } from 'react';
import { Divider } from '@stereoagency/ui';
import { LinesContext } from '@/components/LinesContext';

type Props = {
  data: {
    variant: 'full-width' | 'small'
    background: 'transparent' | 'gray'
  }
};

export default function NvisoDivider({
  data: {
    variant, background,
  },
}: Props) {
  const { enableLines } = useContext(LinesContext);

  return (
    <Divider enableLines={enableLines} variant={variant} background={background === 'gray' ? 'colored' : 'transparent'} />
  );
}
